import {
  ExpGlobalDataDTO,
  FileResponse,
  GlobalDataComparisonRequestDTO,
  HomeClient,
} from 'business/models/Models';
import ModelFactory from 'business/models/ModelFactory';

async function GetGlobalDataService(): Promise<ExpGlobalDataDTO> {
  const home: HomeClient = ModelFactory(HomeClient);
  const gdata = await home.getExpGlobalData();

  return gdata;
}

async function GetGlobalComparisonDataService(
  globalDataComparisonRequestDTO: GlobalDataComparisonRequestDTO,
): Promise<ExpGlobalDataDTO> {
  const home: HomeClient = ModelFactory(HomeClient);
  const gdata = await home.getExpGlobalComparisonData(globalDataComparisonRequestDTO);
  return gdata;
}

async function GetAppInfoData() {
  const home: HomeClient = ModelFactory(HomeClient);
  const appInfoData = await home.getAppInfo();
  return appInfoData;
}

async function UpdateGlobalDataStoreVersion(storeNames: string[]): Promise<FileResponse> {
  const home: HomeClient = ModelFactory(HomeClient);
  return await home.updateGlobalDataStoreVersion(storeNames);
}

export {
  GetGlobalDataService,
  GetAppInfoData,
  GetGlobalComparisonDataService,
  UpdateGlobalDataStoreVersion,
};
